import { render } from "./SOPs.vue?vue&type=template&id=0d34ff83&scoped=true"
import script from "./SOPs.vue?vue&type=script&lang=js"
export * from "./SOPs.vue?vue&type=script&lang=js"

import "./SOPs.vue?vue&type=style&index=0&id=0d34ff83&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d34ff83"]])

export default __exports__